import { render, staticRenderFns } from "./InsurancePolicies.vue?vue&type=template&id=561dd13c&"
import script from "./InsurancePolicies.vue?vue&type=script&lang=js&"
export * from "./InsurancePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports